import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {
    Button,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton, Tooltip
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import "./InstructionsBox.css";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {MdDelete, MdEdit, MdErrorOutline} from "react-icons/md";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import EditDocumentModal from "./EditDocumentModal";

const DocumentUploader = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [file, setFile] = useState(null);
    const [name, setName] = useState('');
    const [language, setLanguage] = useState('ქართული');
    const [filterLanguage, setFilterLanguage] = useState(''); // New state for filtering language
    const [error, setError] = useState('');
    const [documents, setDocuments] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [inputKey, setInputKey] = useState(Date.now());
    const [alertInfo, setAlertInfo] = useState({open: false, message: '', type: ''});
    const [isModalOpenForUpload, setIsModalOpenForUpload] = useState(false);
    const [isModalOpenForDelete, setIsModalOpenForDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [currentDocument, setCurrentDocument] = useState(null);


    const handleDeleteDocument = async () => {
        try {
            setIsLoading(true)
            const response = await axios.put(`${baseURL}/DeleteDocumentDrive`, {id: selectedDocId});
            if (response.data.success) {
                setAlertInfo({open: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
                await fetchDocuments();
                setIsModalOpenForDelete(false)
            } else {
                setAlertInfo({open: true, message: 'Failed to delete document', type: 'error'});
            }
        } catch (error) {
            setAlertInfo({open: true, message: 'Error deleting document', type: 'error'});
        }
    };


    useEffect(() => {
        void fetchDocuments();
    }, []);

    const fetchDocuments = async () => {
        try {
            const response = await axios.get(`${baseURL}/GetAllDocumentDrive`);
            if (response.data.success) {
                setDocuments(response.data.data);
                setIsLoading(false)
            } else {
                setError("Failed to fetch documents.");
            }
        } catch (error) {
            setError("Error fetching documents.");
        }
    };

    const handleFileChange = event => {
        let selectedFile = event.target.files[0];
        if (selectedFile && selectedFile.type === "application/pdf") {
            if (selectedFile.size <= 10485760) {
                setFile(selectedFile);
                setPreviewUrl(URL.createObjectURL(selectedFile));
                setError('');
            } else {
                setError('მაქსიმალური ზომა: 10 mb.');
            }
        } else {
            setError('ატვირთეთ მხოლოდ .pdf ფაილები');
        }
    };

    const filteredDocuments = documents.filter(doc => {
        const matchesSearchQuery = doc.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesLanguage = filterLanguage ? doc.language === filterLanguage : true;
        return matchesSearchQuery && matchesLanguage;
    });


    const handleSubmit = async () => {
        setIsLoading(true)
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = async () => {
            const base64String = fileReader.result.split(',')[1];
            try {
                const response = await axios.post(`${baseURL}/AddNewDocumentDrive`, {
                    name,
                    description: '',
                    language,
                    file: {
                        base64String,
                        ext: "pdf"
                    }
                });
                if (response.data.success) {
                    setAlertInfo({open: true, message: 'ფაილი გაიგზავნა', type: 'success'});
                    setName('');
                    setFile(null);
                    setPreviewUrl(null);
                    setSearchQuery('')
                    setFilterLanguage('')
                    setInputKey(Date.now()); // Reset file input
                } else {
                    setAlertInfo({open: true, message: 'Error uploading file', type: 'error'});
                }
                await fetchDocuments();
                setIsModalOpenForUpload(false)

            } catch (error) {
                setAlertInfo({open: true, message: 'Error uploading file', type: 'error'});
            }
        };
    };


    const handleCloseAlert = () => {
        setAlertInfo(prev => ({...prev, open: false}));
    };
    const copyToClipboard = async (url) => {
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard.writeText(url.trim()).then(() => {
                setAlertInfo({open: true, message: 'დაკოპირდა', type: 'success'});
            }).catch(err => {
                console.error('Failed to copy: ', err);
                setAlertInfo({open: true, message: 'Error copying to clipboard', type: 'error'});
            });
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = url.trim();
            textArea.style.position = "absolute";
            textArea.style.left = "-9999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                const msg = successful ? 'დაკოპირდა' : 'Error copying to clipboard';
                setAlertInfo({open: true, message: msg, type: successful ? 'success' : 'error'});
            } catch (err) {
                console.error('Failed to copy with execCommand: ', err);
                setAlertInfo({open: true, message: 'Error copying to clipboard', type: 'error'});
            }

            document.body.removeChild(textArea);
        }
    };


    const openConfirmModal = () => {
        setIsModalOpenForUpload(true)
    }

    const openEditModal = (doc) => {
        setCurrentDocument(doc);
        setIsEditModalOpen(true);
    };

    return (
        <div className={"holiday-picker-main-container"}>

            <h1 className="employee-form-title">საჯარო დოკუმენტების საცავი</h1>
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                <TextField
                    label="ფაილის სახელი"
                    variant="outlined"
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                <div>
                    {previewUrl && (
                        <div>
                            <iframe src={previewUrl} style={{width: '100%', height: '500px'}}></iframe>
                            <Button variant="contained" color="secondary" onClick={() => {
                                setFile(null);
                                setPreviewUrl(null);
                                setInputKey(Date.now());
                            }}>
                                წაშლა
                            </Button>
                        </div>
                    )}
                </div>

                <FormControl fullWidth>
                    <InputLabel id="language-label">ენა</InputLabel>
                    <Select
                        labelId="language-label"
                        value={language}
                        label="ენა"
                        onChange={e => setLanguage(e.target.value)}
                    >
                        <MenuItem value="ქართული">ქართული</MenuItem>
                        <MenuItem value="ინგლისური">ინგლისური</MenuItem>
                    </Select>
                </FormControl>
                <Button
                    variant="contained"
                    component="label"
                    color="primary"
                >
                    ფაილის ატვირთვა
                    <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                        accept=".pdf"
                        key={inputKey}
                    />
                </Button>
                {error && <p style={{color: 'red'}}>{error}</p>}
                <Button onClick={openConfirmModal} type="submit" variant="contained" color="primary"
                        disabled={!name.trim() || !file}>
                    გაგზავნა
                </Button>
            </div>


            <TableContainer component={Paper} style={{marginTop: '20px'}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <TextField
                                    label="ფაილის სახელი"
                                    variant="outlined"
                                    value={searchQuery}
                                    onChange={e => setSearchQuery(e.target.value)}
                                />
                            </TableCell>


                            <TableCell>
                                <FormControl fullWidth style={{width: '300px'}}>
                                    <InputLabel id="filter-language-label">ენა</InputLabel>
                                    <Select
                                        labelId="filter-language-label"
                                        value={filterLanguage}
                                        label="ენა"
                                        onChange={e => setFilterLanguage(e.target.value)}
                                        style={{width: '200px'}} // Fixed width for the dropdown
                                    >
                                        <MenuItem value="">ყველა</MenuItem>
                                        <MenuItem value="ქართული">ქართული</MenuItem>
                                        <MenuItem value="ინგლისური">ინგლისური</MenuItem>
                                    </Select>
                                </FormControl>
                            </TableCell>
                            <TableCell>დოკუმენტის ბმული</TableCell>
                            <TableCell>ქმედება</TableCell>
                        </TableRow>
                    </TableHead>

                    {

                        isLoading ? (
                                <TableBody>
                                    <LoaderCustom/>
                                </TableBody>
                            ) :

                            documents.length === 0 ? (

                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={4} style={{textAlign: "center"}}>
                                                <div className={"flow-error"}>

                                                    თქვენ არ გაქვთ ატვირთული ფაილები
                                                    <MdErrorOutline style={{marginLeft: '10px', fontSize: '24px'}}/>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>

                                )
                                :
                                filteredDocuments.length === 0 ? (

                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={4} style={{textAlign: "center"}}>
                                                    <div className={"flow-error"}>

                                                        არაფერი მოიძებნა
                                                        <MdErrorOutline style={{marginLeft: '10px', fontSize: '24px'}}/>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>

                                    )
                                    :
                                    (
                                        <TableBody>
                                            {filteredDocuments.map((doc) => (
                                                <TableRow key={doc.id}>
                                                    <TableCell>{doc.name}</TableCell>
                                                    <TableCell>{doc.language}</TableCell>
                                                    <TableCell>
                                                        <a href={doc.filePath} target="_blank"
                                                           rel="noopener noreferrer">დოკუმენტის
                                                            ნახვა</a>
                                                        <IconButton onClick={() => copyToClipboard(doc.filePath)}>
                                                            <ContentCopyIcon/>
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Tooltip title={"წაშლა"}>
                                                            <IconButton
                                                                style={{color: 'red'}}
                                                                onClick={() => {
                                                                    setSelectedDocId(doc.id);
                                                                    setIsModalOpenForDelete(true);
                                                                }}>

                                                                <MdDelete/>
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={"რედაქტირება"}>
                                                            <IconButton onClick={() => openEditModal(doc)}>
                                                                <MdEdit/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    )}

                </Table>
            </TableContainer>
            {alertInfo.open && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={handleCloseAlert}
                />
            )}
            <ConfirmationModal
                isOpen={isModalOpenForUpload}
                onRequestClose={() => setIsModalOpenForUpload(false)}
                onConfirm={handleSubmit}
            />
            <ConfirmationModal
                isOpen={isModalOpenForDelete}
                onRequestClose={() => setIsModalOpenForDelete(false)}
                onConfirm={handleDeleteDocument}
            />
            <EditDocumentModal
                open={isEditModalOpen}
                handleClose={() => setIsEditModalOpen(false)}
                documentData={currentDocument}
                fetchDocuments={fetchDocuments}
            />
        </div>
    );
};

export default DocumentUploader;


